import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            内容分类导航
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            八大内容分类，总有一款适合你的口味
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${cat.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-500 font-medium">
                {cat.itemCount.toLocaleString()} 个内容
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}